module.exports = __webpack_public_path__ + "img/car_00013.a969a311.jpg";